import { render, staticRenderFns } from "./ListDriversPage.vue?vue&type=template&id=74dc7df2"
import script from "./ListDriversPage.vue?vue&type=script&lang=js"
export * from "./ListDriversPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports